export default __webpack_public_path__ + "static/media/finture.b491d718.svg";